<template>
  <div class="has-background-primary-light  has-text-centered is-size-7-mobile container is-hidden-mobile advantages">
    <div v-bind:class="[size === 'large' ? 'advantages--large' : 'advantages--small']">
      <h2 class="title is-size-6-mobile" v-bind:class="[size === 'large' ? 'is-4' : 'is-size-5']">
        {{ $whitelabel.firstNameBasis ? $t('voucher-advantages.benefits-slogan-fnb') : $t('voucher-advantages.benefits-slogan') }}
      </h2>
      <div class="columns advantages mt-2 mb-1 has-text-weight-bold  is-multiline is-mobile" v-bind:class="[size === 'large' ? 'is-uppercase' : '']">
        <div class="column is-6-mobile" v-if="$whitelabel.short.toLowerCase() !== 'adac'">
          <div class="box p-2 pl-3 pr-3">
            <b-icon icon="check-circle" class="has-text-primary"></b-icon>
            <p>{{ $t('voucher-advantages.warranty') }}</p>
          </div>
        </div>
        <div class="column is-6-mobile">
          <div class="box p-2 pl-3 pr-3">
            <b-icon icon="check-circle" class="has-text-primary"></b-icon>
            <p>
              <span v-if="$whitelabel.short.toLowerCase() !== 'greenstorm'">{{ $t('voucher-advantages.up-to') }}</span> {{ $t('voucher-advantages.three-years-valid') }}
            </p>
          </div>
        </div>
        <!-- <div class="column is-6-mobile" v-if="$whitelabel.short.toLowerCase() === 'greenstorm'">
          <div class="box p-2 pl-3 pr-3">
            <b-icon icon="check-circle" class="has-text-primary"></b-icon>
            <p>{{ $t('voucher-advantages.money-back-gurantee') }}</p>
          </div>
        </div> -->
        <div class="column is-6-mobile">
          <div class="box p-2 pl-3 pr-3">
            <b-icon icon="check-circle" class="has-text-primary"></b-icon>
            <p>{{ $t('voucher-advantages.flex') }}</p>
          </div>
        </div>
        <div class="column is-6-mobile">
          <div class="box p-2 pl-3 pr-3">
            <b-icon icon="check-circle" class="has-text-primary"></b-icon>
            <p>{{ $t('voucher-advantages.verified-hotels') }}</p>
          </div>
        </div>
        <div class="column is-6-mobile">
          <div class="box p-2 pl-3 pr-3">
            <b-icon icon="check-circle" class="has-text-primary"></b-icon>
            <p>{{ $t('voucher-advantages.best-gift') }}</p>
          </div>
        </div>
        <div class="column is-6-mobile has-text-right advantages-button" v-if="size === 'small'">
          <b-button tag="router-link" :to="$t('voucher-advantages.url')" type="is-dark" icon-left="angle-double-right">
            {{ $t('voucher-advantages.all-advantages') }}
          </b-button>
        </div>
      </div>
      <p v-bind:class="[size === 'small' ? 'has-text-right' : '']" v-if="size === 'large'">
        <router-link :to="$t('voucher-advantages.url')" class="is-inline-block has-text-grey-darker has-text-weight-bold"><i class="fas fa-angle-double-right"></i> {{ $t('voucher-advantages.all-advantages') }}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Advantages',
  props: {
    size: String,
  },
}
</script>

<style scoped lang="scss">
.advantages--large {
  padding: 2rem 1rem;
}

.advantages--small {
  padding: 1rem;

  @media screen and (min-width: 1216px) {
    .columns {
      justify-content: space-between;
      align-items: center;
    }
  }

  .column {
    font-size: 0.9rem !important;
    flex-basis: unset;
    flex-grow: unset;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .icon {
    display: none;
  }
}

.advantages {
  .column {
    padding-bottom: 0;
  }
  @media screen and (max-width: 1215px) {
    justify-content: space-between;
  }
}

.advantages-button {
  @media screen and (min-width: 1216px) {
    margin-left: auto;
  }
}
</style>
